import * as React from 'react';
import Step from '../Step';
import { StepProperties } from '../Step';
import { FilespaceNameStep } from './FilespaceNameStep';

interface FilespaceNameWizardStepState {
    filespaceName: string;
}

interface FilespaceNameWizardStepProperties extends StepProperties<FilespaceNameWizardStepState> {
    maxNameLength: number;
    filespaces: Array<string>;
    domainName: string;
}

class FilespaceNameWizardStep extends Step<
    FilespaceNameWizardStepProperties,
    FilespaceNameWizardStepState,
    FilespaceNameWizardStepState
> {
    constructor(props: FilespaceNameWizardStepProperties) {
        super(props);

        this.onNameChanged = this.onNameChanged.bind(this);

        this.state = {
            ...this.props.savedState
        };
    }

    render() {
        return (
            <FilespaceNameStep
                filespaceName={this.state.filespaceName}
                filespaces={this.props.filespaces}
                domainName={this.props.domainName}
                onNameChanged={this.onNameChanged}
                completeStep={this.completeStep}
                buttonState={{ text: 'Next' }}
                maxNameLength={this.props.maxNameLength}
            />
        );
    }

    protected getSharedStepState(): FilespaceNameWizardStepState {
        return {
            filespaceName: this.state.filespaceName,
        };
    }

    private onNameChanged(filespaceName: string): void {
        this.setState({ filespaceName });
    }
}

export { FilespaceNameWizardStep, FilespaceNameWizardStepProperties, FilespaceNameWizardStepState };



// WEBPACK FOOTER //
// ./src/webportal/components/wizard/components/FilespaceNameWizardStep.tsx